import { CHARACTER_VISIBILITY } from "./sharedTypes";
import { t } from "i18next";
export const MAX_TOKEN_LIMIT = 2400;
export const MIN_TOKEN_LIMIT = 100;
export const GOOD_TOKEN_LIMIT = 1600;
// will be removed later, adding it to make things backward compatible
export const TOKEN_ERROR_MESSAGE = `Error: The bot is not currently optimized. Please ensure Token Count is in between ${MIN_TOKEN_LIMIT} and ${MAX_TOKEN_LIMIT}.`;
export const LESS_TOKEN_ERROR_MESSAGE = `Public chatbots must feature at least ${MIN_TOKEN_LIMIT} tokens of content. Improve your persona or greeting.`;
export const MORE_TOKEN_ERROR_MESSAGE = `Chatbots must not exceed ${MAX_TOKEN_LIMIT} tokens, streamline your definition to make it public.`;
export const GOOD_TOKEN_WARNING_MESSAGE = `Consider keeping your chatbot under ${GOOD_TOKEN_LIMIT} tokens for optimal performance.`;
// V2 design messages, will be removed later
export const LESS_TOKEN_ERROR_MESSAGE_V2 = () => t("error:tokenCount.lessTokenError", { min: MIN_TOKEN_LIMIT });
export const MORE_TOKEN_ERROR_MESSAGE_V2 = () => t("error:tokenCount.moreTokenError");
export const GOOD_TOKEN_WARNING_MESSAGE_V2 = () => t("error:tokenCount.goodTokenWarning", { limit: GOOD_TOKEN_LIMIT });
const getTokenCountErrorAndWarnings = (tokenCount, version) => {
    if (tokenCount > MAX_TOKEN_LIMIT) {
        return {
            errorMessage: version === "v2"
                ? MORE_TOKEN_ERROR_MESSAGE_V2()
                : MORE_TOKEN_ERROR_MESSAGE,
        };
    }
    if (tokenCount < MIN_TOKEN_LIMIT) {
        return {
            errorMessage: version === "v2"
                ? LESS_TOKEN_ERROR_MESSAGE_V2()
                : LESS_TOKEN_ERROR_MESSAGE,
        };
    }
    if (tokenCount > GOOD_TOKEN_LIMIT) {
        return {
            warningMessage: version === "v2"
                ? GOOD_TOKEN_WARNING_MESSAGE_V2()
                : GOOD_TOKEN_WARNING_MESSAGE,
        };
    }
    return {};
};
export const isCharacterTokenCountValid = (totalToken, characterVisibility, version = "v1") => {
    if (characterVisibility !== CHARACTER_VISIBILITY.PUBLIC) {
        return { isValid: true };
    }
    const { errorMessage, warningMessage } = getTokenCountErrorAndWarnings(totalToken, version);
    if (errorMessage) {
        return { isValid: false, errorMessage };
    }
    if (warningMessage) {
        return { isValid: true, warningMessage };
    }
    return { isValid: true };
};
